import React, { useEffect, useState } from 'react';


const Chart = ({ children, height, width }) => {
    const isPercent = typeof width === 'string' && width.includes('%');
    return (
        <svg
            {...(!isPercent && { viewBox: `0 0 ${width} ${height}` })}
            height={height}
            width={width}
            preserveAspectRatio="xMidYMid meet"
            style={{
                overflow: 'visible',
                willChange: 'transform',
                transform: 'translateZ(0)',
            }}
        >
            {children}
        </svg>
    );
};

const Bar = ({ x, y, height, width, fill }) => (
    <rect fill={fill} x={x} y={y} rx={11} ry={11} height={height} width={width} />
)

const BarChartBox = ({ data }) => {
    const [key, setKey] = useState(0);

    useEffect(() => {
        const timer = setTimeout(() => setKey(prev => prev + 1), 100);
        return () => clearTimeout(timer);
    }, []);

    const barWidth = 22;
    const barMargin = 20;
    const maxStep = data.reduce((max, curr) => curr.step > max ? curr.step : max, 0);
    const height = maxStep === 0 ? 1 : maxStep;


    return (
        <>
            <Chart
                height='100%'
                width='100%'
            >
                {data.map((datum, index) => (
                    <React.Fragment key={datum.date}>
                        <Bar
                            fill="#9FC1F0"
                            x={index * (barWidth + barMargin)}
                            y={(100 - (datum.step * 65) / height) + '%'}
                            width={barWidth}
                            height={(datum.step * 65) / height + '%'}
                        />

                        <text className='counter'
                            x={datum.step < 1000 ? (index * (barWidth + barMargin) - 1) :
                                datum.step > 9999 ? (index * (barWidth + barMargin) - 10) :
                                    (index * (barWidth + barMargin) - 4)
                            }
                            y={(78 - (datum.step * 65) / height) + '%'}
                            fontSize='12'
                            fill='#1065D9'
                        >
                            {datum.step.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}
                        </text>

                        <text x={index * (barWidth + barMargin)} y={92 + '%'} fontSize='12' fill='#82868C'>{datum.date}</text>

                        {datum.day && <text x={index * (barWidth + barMargin)} y={99 + '%'} fontSize='12' fontWeight="700" fill='#1065D9'>{datum.day}</text>}

                    </React.Fragment>
                ))}

            </Chart>
        </>
    )
};

export default BarChartBox;